import React from 'react';

import { cn } from '@april9au/react-common/utils';

import type { IconName } from './icons/name.d.ts';
import href from './icons/sprite.svg';

export { href };
export type { IconName };

/**
 * Renders an SVG icon. The icon defaults to the size of the font. To make it
 * align vertically with neighboring text, you can pass the text as a child of
 * the icon and it will be automatically aligned.
 * Alternatively, if you're not ok with the icon being to the left of the text,
 * you need to wrap the icon and text in a common parent and set the parent to
 * display "flex" (or "inline-flex") with "items-center" and a reasonable gap.
 */
export function Icon({
  name,
  className,
  children,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  name: IconName;
}) {
  if (children) {
    return (
      <span className={`inline-flex items-center gap-x-2`}>
        <Icon name={name} className={className} {...props} />
        {children}
      </span>
    );
  }

  return (
    <svg {...props} className={cn('inline size-[1em] self-center', className)} data-slot="icon">
      <use href={`${href}#${name}`} />
    </svg>
  );
}
